import Type from "@/model/types/Type";

const type = {
    NOT : 0,
    SHARE_ALL_PHOTOS : 10,
}

const list = [
    {
        value: type.NOT,
        text: "Restrito",
    },
    {
        value: type.SHARE_ALL_PHOTOS,
        text: "Público através de URL",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}